import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdirectiveInject, ViewContainerRef, TemplateRef, ɵɵdefineDirective, Directive, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { first, tap } from 'rxjs/operators';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

class FeatureToggleLibService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.enabledFeatures = [];
    }
    hasFlags(toCheck) {
        const flagsToCheck = Array.isArray(toCheck) ? toCheck : [toCheck];
        return flagsToCheck.some(flagToCheck => this.enabledFeatures.some(enabledFeatureFlag => flagToCheck === enabledFeatureFlag));
    }
    getFeatureFlags(userId) {
        return this.httpClient
            .get('/assets/feature-flags.json?userId=' + userId)
            .pipe(first(), tap((features) => {
            if (!features) {
                throw new Error('No features!');
            }
            this.enabledFeatures = this.getEnabledFlags(features);
        }));
    }
    getEnabledFlags(features) {
        const enabledFeatures = [];
        for (const key in features) {
            if (features.hasOwnProperty(key)) {
                const isEnabled = features[key];
                if (isEnabled || !!sessionStorage.getItem(key)) {
                    enabledFeatures.push(key);
                }
            }
        }
        return enabledFeatures;
    }
}
FeatureToggleLibService.ɵfac = function FeatureToggleLibService_Factory(t) { return new (t || FeatureToggleLibService)(ɵɵinject(HttpClient)); };
FeatureToggleLibService.ɵprov = ɵɵdefineInjectable({ token: FeatureToggleLibService, factory: FeatureToggleLibService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FeatureToggleLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class FeatureToggleLibDirective {
    constructor(vcr, tpl, featureToggleLibService) {
        this.vcr = vcr;
        this.tpl = tpl;
        this.featureToggleLibService = featureToggleLibService;
    }
    ngOnInit() {
        if (this.featureToggleLibService.hasFlags(this.featureFlag)) {
            this.vcr.createEmbeddedView(this.tpl);
        }
    }
}
FeatureToggleLibDirective.ɵfac = function FeatureToggleLibDirective_Factory(t) { return new (t || FeatureToggleLibDirective)(ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(TemplateRef), ɵɵdirectiveInject(FeatureToggleLibService)); };
FeatureToggleLibDirective.ɵdir = ɵɵdefineDirective({ type: FeatureToggleLibDirective, selectors: [["", "ftAppFeatureToggle", ""]], inputs: { featureFlag: ["ftAppFeatureToggle", "featureFlag"] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FeatureToggleLibDirective, [{
        type: Directive,
        args: [{
                selector: '[ftAppFeatureToggle]',
            }]
    }], function () { return [{ type: ViewContainerRef }, { type: TemplateRef }, { type: FeatureToggleLibService }]; }, { featureFlag: [{
            type: Input,
            args: ['ftAppFeatureToggle']
        }] }); })();

class FeatureToggleLibModule {
}
FeatureToggleLibModule.ɵmod = ɵɵdefineNgModule({ type: FeatureToggleLibModule });
FeatureToggleLibModule.ɵinj = ɵɵdefineInjector({ factory: function FeatureToggleLibModule_Factory(t) { return new (t || FeatureToggleLibModule)(); }, providers: [FeatureToggleLibModule], imports: [[CommonModule, HttpClientModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FeatureToggleLibModule, { declarations: [FeatureToggleLibDirective], imports: [CommonModule, HttpClientModule], exports: [FeatureToggleLibDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FeatureToggleLibModule, [{
        type: NgModule,
        args: [{
                declarations: [FeatureToggleLibDirective],
                imports: [CommonModule, HttpClientModule],
                exports: [FeatureToggleLibDirective],
                providers: [FeatureToggleLibModule],
            }]
    }], null, null); })();

class FeatureToggleCanActivateGuard {
    constructor(featureToggleService) {
        this.featureToggleService = featureToggleService;
    }
    canActivate(route) {
        return this.featureToggleService.hasFlags(route.data.flags);
    }
}
FeatureToggleCanActivateGuard.ɵfac = function FeatureToggleCanActivateGuard_Factory(t) { return new (t || FeatureToggleCanActivateGuard)(ɵɵinject(FeatureToggleLibService)); };
FeatureToggleCanActivateGuard.ɵprov = ɵɵdefineInjectable({ token: FeatureToggleCanActivateGuard, factory: FeatureToggleCanActivateGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FeatureToggleCanActivateGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: FeatureToggleLibService }]; }, null); })();

class FeatureToggleCanLoadGuard {
    constructor(featureToggleService) {
        this.featureToggleService = featureToggleService;
    }
    canLoad(route) {
        return this.featureToggleService.hasFlags(route.data.flags);
    }
}
FeatureToggleCanLoadGuard.ɵfac = function FeatureToggleCanLoadGuard_Factory(t) { return new (t || FeatureToggleCanLoadGuard)(ɵɵinject(FeatureToggleLibService)); };
FeatureToggleCanLoadGuard.ɵprov = ɵɵdefineInjectable({ token: FeatureToggleCanLoadGuard, factory: FeatureToggleCanLoadGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FeatureToggleCanLoadGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: FeatureToggleLibService }]; }, null); })();

/*
 * Public API Surface of feature-toggle-lib
 */
// #export * from './lib/feature-toggle-preload-strategy';

/**
 * Generated bundle index. Do not edit.
 */

export { FeatureToggleCanActivateGuard, FeatureToggleCanLoadGuard, FeatureToggleLibDirective, FeatureToggleLibModule, FeatureToggleLibService };
//# sourceMappingURL=feature-toggle-lib.js.map
